import React from 'react';
import PropTypes from 'prop-types';

import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';
import TierRow from './tier_row';

const isCustom = (schedule) => {
  return schedule.royaltyPatternName === 'custom';
};

export function TiersInputTable({ schedule, onChange }) {
  const canEdit = schedule.canEdit && isCustom(schedule);

  const addTier = () => {
    const newTiers = [...schedule.tiers];

    const lastTier = newTiers[newTiers.length - 1];

    newTiers.push({ from: lastTier ? lastTier.to : 0, to: null, royaltyPercentage: 0 });

    onChange({ tiers: newTiers });
  };

  const handleTierChange = (tier, index) => {
    const newTiers = [...schedule.tiers];

    newTiers[index] = tier;

    onChange({ tiers: newTiers });
  };

  return (
    <div className="d-flex flex-column gap-3">
      <h6>Tiers</h6>
      <div className="table-container">
        <table className="table table-bordered table-form table-form--fixed">
          <thead>
            <tr>
              <th>Tier</th>
              <th className="text-right">From</th>
              <th className="text-right">To</th>
              <th className="text-right">Royalty %</th>
            </tr>
          </thead>

          <tbody>
            {schedule.tiers.map((tier, index) => (
              <TierRow
                canEdit={canEdit}
                index={index}
                isLast={index === schedule.tiers.length - 1}
                key={index}
                tier={tier}
                onChange={handleTierChange}
              />
            ))}
          </tbody>
        </table>
      </div>

      {canEdit &&
        <Button icon={faCirclePlus} label="Add Tier" name="add-tier" size="sm" variant="ghost" onClick={addTier} />
      }
    </div>
  );
}

TiersInputTable.propTypes = {
  schedule: PropTypes.shape({
    tiers: PropTypes.array,
    royaltyPatternName: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TiersInputTable;
